import { Row, Col, Button, Typography, Input } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../../stores/slices/alertSlice";
import { AppDispatch } from "../../../stores/store";
import { ResponseSuscriptorDataGeneralDatum } from "../../../types/common";
const { Text } = Typography;

interface errorFieldsProps {
    alias: string,
    suscriptor: string,
    fullName: string,
    extNumber: string
}

interface Props {
    item: ResponseSuscriptorDataGeneralDatum,
    handleCancel: Function,
    handleEdit: Function
}

const EditContract = (props: Props) => {
    const { item, handleCancel, handleEdit } = props;

    const emptyErrorFields: errorFieldsProps = {
        alias: "",
        suscriptor: "",
        fullName: "",
        extNumber: ""
    }
    const [alias, setAlias] = useState("");
    const [idCliente, setIdCliente] = useState("");
    const [fullName, setFullName] = useState("");
    const [extNumber, setExtNumber] = useState(0);
    const [isAssociatedC, setIsAssociatedC] = useState(false);

    const [errorsEmptyFields, setErrorsEmptyFields] = useState<errorFieldsProps>(emptyErrorFields);

    const handleChangeAlias = (value: string) => {
        errorsEmptyFields.alias = "";
        setAlias(value);
    }

    const dispatch = useDispatch<AppDispatch>();

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    // Manejador para el alert
    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    const validate = () => {
        let error = "";
        let errorFields: errorFieldsProps = {
            alias: "",
            suscriptor: "",
            fullName: "",
            extNumber: ""
        }

        if (!alias) {
            let message = "El campo Alias está vacío.\n";
            error += message;
            errorFields.alias = message;
        }

        setErrorsEmptyFields(errorFields);
        if (error !== "") {
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "ERROR",
                title: "¡Estimado Usuario!",
                message: error,
                onFinalize: () => handleDispatchAlertModal()
            }
            openAlertModal(dispatchAlert);
        }

        // si no hubo errores, procede al siguiente paso
        if (error === "") {
            handleEdit(alias, idCliente, isAssociatedC);
        }
    }

    useEffect(() => {
        setAlias(item.alias);
        setIdCliente(item.sucursal + item.suscriptor);
        setFullName(item.nombre + " " + item.apellidoPaterno + " " + item.apellidoMaterno);
        setExtNumber(item.numeroExterior);
        setIsAssociatedC(item.isAssociatedContract);
    }, [item]);

    return (
        <>
            <Row gutter={[30, 16]} style={{ marginTop: 20 }}>
                <Col xs={24} xl={12}>
                    <Text style={styles.inputTitle}>Alias</Text>
                    <Input
                        placeholder="Alias de contrato asociado"
                        value={alias}
                        style={styles.inputText}
                        onChange={(event) => handleChangeAlias(event.target.value)}
                        status={errorsEmptyFields.alias ? "error" : ""}
                    />
                    {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.alias ? errorsEmptyFields.alias : null}</Text>}
                </Col>
                <Col xs={24} xl={12}>
                    <Text style={styles.inputTitle}>Número de Suscriptor</Text>
                    <Input
                        placeholder="Número de suscriptor"
                        value={idCliente}
                        style={styles.inputText}
                        disabled
                    />
                </Col>
                <Col xs={24} xl={12}>
                    <Text style={styles.inputTitle}>Nombre del Suscriptor</Text>
                    <Input
                        placeholder="Nombre de suscriptor"
                        value={fullName}
                        style={styles.inputText}
                        disabled
                    />
                </Col>
                <Col xs={24} xl={12}>
                    <Text style={styles.inputTitle}>Número Exterior</Text>
                    <Input
                        placeholder="Número exterior"
                        value={extNumber}
                        style={styles.inputText}
                        disabled
                    />
                </Col>
            </Row>
            <div style={styles.containerButtons}>
                <Button
                    size='large'
                    style={styles.buttonPrimary}
                    onClick={() => handleCancel()}
                >
                    {"Cancelar"}
                </Button>
                <Button
                    size='large'
                    style={styles.buttonPrimary}
                    onClick={() => validate()}
                >
                    {"Guardar"}
                </Button>
            </div>
        </>
    );
};
const styles = StyleSheet.create({
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputText: {
        marginTop: 15,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    emptyFieldError: {
        fontSize: 11
    },
    buttonPrimary: {
        backgroundColor: '#0055c2',
        borderRadius: 30,
        color: 'white',
        border: "none",
        padding: "5px 30px",
        height: 35,
        marginLeft: 15,
        marginRight: 15
    },
    containerButtons: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center'
    },
});

export default EditContract;
